import type { ElementType, ReactNode } from 'react'

interface SectionTitleProps {
  children: ReactNode
  className?: string
  wrapperClassName?: string
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl'
  level?: 1 | 2 | 3 | 4 | 5 | 6
  extra?: ReactNode
  addon?: ReactNode
}

const SectionTitle = ({
  children,
  className = 'text-slate-600',
  wrapperClassName = '',
  size = '3xl',
  level = 2,
  extra,
  addon,
}: SectionTitleProps) => {
  const textSize = `text-${size}`
  const Component = `h${level}` as ElementType

  return (
    <div className={`flex items-center justify-between ${wrapperClassName}`}>
      <div className="flex items-center gap-2">
        <Component className={`${textSize} font-bold ${className || ''}`}>{children}</Component>
        {addon}
      </div>
      {extra}
    </div>
  )
}

export default SectionTitle
